<template>
  <el-dialog
    :title="id==0 ? '添加链接配置' : '编辑链接配置'"
    :visible.sync="visible"
    :before-close="closeDialog"
    @closed="closeDialog"
    width="40%"
    @opened="addOpen"
    :close-on-click-modal="false">
    <el-form :model="formData" :rules="formRules" ref="formRef" label-width="80px">
      <el-form-item label="标题" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="链接" prop="content">
        <el-input v-model="formData.content"></el-input>
      </el-form-item>
      <el-form-item label="模块" prop="m_id">
        <el-select v-model="formData.m_id" placeholder="请选择模块">
          <el-option label="请选择模块" :value="0"></el-option>
          <el-option v-for="item in mIdList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期" prop="day_time">
        <el-date-picker v-model="formData.day_time" type="date" placeholder="选择日期" value-format="timestamp"></el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'config_link_add',
  props: [
    'visible', 'id', 'mIdList'
  ],
  data () {
    return {
      formData: {
        title: '',
        content: '',
        m_id: 0,
        day_time: 0
      },
      formRules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '链接不能为空', trigger: 'blur' }
        ],
        day_time: [
          { required: true, message: '日期不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.formRef.resetFields()
      this.$emit('close')
    },
    addConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.formData.day_time = this.formData.day_time / 1000
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.getInfo(this.id)
      }

      if (this.formData.day_time === 0) {
        this.formData.day_time = new Date(new Date().toLocaleDateString()).getTime()
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/config_link/info/' + id)
      if (res.code === 0) {
        this.formData = {
          day_time: res.data.day_time * 1000,
          title: res.data.title,
          content: res.data.content,
          m_id: res.data.m_id
        }
      }
    }
  }
}
</script>

<style>
</style>
